import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M17.8 21.2h9.5v2.5h-9.5zM35.5 21.2H45v2.5h-9.5zM0 21.2h9.5v2.5H0zM21.2 35.5h2.5V45h-2.5zM21.2 0h2.5v9.5h-2.5z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3zM28.9 2.5v5.8c0 2.3.9 4.3 2.4 5.8H14.1c1.5-1.5 2.4-3.6 2.4-5.8V2.5h12.4zM2.5 3c0-.3.2-.5.5-.5h11v5.8c0 3.2-2.6 5.8-5.8 5.8H2.5V3zM3 42.5c-.3 0-.5-.2-.5-.5V31.6h5.6c3.2 0 5.8 2.6 5.8 5.8v5.1H3zm13.5 0v-5.1c0-2.3-.9-4.3-2.4-5.8h17.2c-1.5 1.5-2.4 3.6-2.4 5.8v5.1H16.5zm26-.5c0 .3-.2.5-.5.5H31.4v-5.1c0-3.2 2.6-5.8 5.8-5.8h5.3V42zm0-12.9H2.5V16.6h40v12.5zm-2.3-15h-3c-3.2 0-5.8-2.6-5.8-5.8V2.5H42c.3 0 .5.2.5.5v11.1h-2.3z"
	})]
});
export default SvgIcon;
